<template>
    <div><!-- 部材品質異常聯絡單 -->
        <CCard>
            <CCardBody>
                <div class="d-flex justify-content-end mb-2">
                    <button class="btn btn-sm btn-success"  v-if="canSave" @click="savedDataEvent(false)">{{$t('Buttons.SavedData')}}</button>
                    <button class="btn btn-sm btn-info ml-2"  v-if="canSave" @click="savedDataEvent(true)">{{$t('Buttons.SaveAndContinue')}}</button>
                    <button class="btn btn-sm btn-dark ml-2" @click="$router.go(-1)">{{$t('Buttons.GoBack')}}</button>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="title" :class="{left: lang === 'en'}">{{ i18n("Element.Vendor") }}&emsp;&emsp;</div>
                        <div class="content">
                          <Select2 style="width: 500px;" v-if="isAddnew" 
                                    v-model="unElRow.vendor"                                     
                                    :options="memberListFilter(factoryId)"
                                    :settings="{ multiple: false, dropdownAutoWidth : true , width: '100%' }"/>
                           <div v-else>{{unElRow.customerName}}</div>         
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="title" :class="{left: lang === 'en'}">{{ i18n("Element.MachineName") }}</div>
                        <div class="content">
                          <input type="text" v-if="isAddnew" maxlength="50" v-model="unElRow.roeModel">
                          <div v-else>{{unElRow.roeModel}}</div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="title" :class="{left: lang === 'en'}">{{ i18n("Element.TrialMassProduction") }}</div>
                        <div class="content"> 
                            <select style="width:200px;" 
                            v-if="isAddnew" v-model="unElRow.dDown_Trial" @change="changeTrial">
                                <option v-for="option in trialMassProductionList" :key="option.trialMassProductionId" :value="option.trialMassProductionId">{{option.trialMassProductionCaption}}</option>
                            </select>
                            <div v-else>
                                <div v-if="unElRow.dDown_Trial === 'MP'">量產</div>
                                <div v-else-if="unElRow.dDown_Trial === 'TR'">試作</div>
                                <div v-else></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="title" :class="{left: lang === 'en'}">{{ i18n("Element.PartNumber") }}</div>
                        <div class="content">
                          <Select2 style="width: 100%;" v-if="isAddnew" 
                                    v-model="unElRow.partnumber" 
                                    :options="partnumberListFilter()" 
                                    :settings="select2Setting()"
                                    @select="partnumberSelectEvent($event)"/>
                           <div v-else>{{unElRow.partnumber}}</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="title" :class="{left: lang === 'en'}">{{ i18n("Element.Parts") }}</div>
                        <div class="content">
                          <input type="text" :disabled="true" v-model="unElRow.partname">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="title" style="width: 130px;" :class="{left: lang === 'en'}">{{ i18n("Element.OccuranceDates") }}</div>
                        <div class="content" style="width: 100%;" >
                            <date-picker :lang="'zh-tw'" format="YYYY-MM-DD" 
                            v-if="isAddnew"
                            valueType="format" v-model="unElRow.happenDate"></date-picker>
                            <div v-else>{{fixDate(unElRow.happenDate)}}</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="title" :class="{left: lang === 'en'}">{{ i18n("Element.OccuranceType") }}</div>
                        <div class="content">
                          <select style="width:200px;" 
                            v-if="isAddnew" v-model="unElRow.happenType" >
                            <option v-for="option in carHappenTypeListFilter" :key="option.happenTypeId" :value="option.happenTypeId">{{option.happenTypeCaption}}</option>
                          </select>
                          <div v-else>{{getHappenTypeTxt(unElRow.happenType)}}</div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="title" :class="{left: lang === 'en'}">{{ i18n("Element.NumberOfAbnormalities") }}</div>
                        <div class="content">
                          <input type="text" :disabled="!isAddnew" v-integer maxlength="10" v-model="unElRow.carCnt">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="title exception" :class="{left: lang === 'en'}">
                          {{ i18n("Element.DefectRate") }}
                          <p>(輸入數字即可)</p>
                        </div>
                        <div class="content">
                          <input type="text" :disabled="!isAddnew" v-integer maxlength="10" v-model="unElRow.carRatio">
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="title" :class="{left: lang === 'en'}">{{ i18n("Element.ContentOfAbnormalities") }}</div>
                        <div class="content">
                            <textarea cols="10" :disabled="!isAddnew"  rows="3" v-model="unElRow.carContent"></textarea>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="title" :class="{left: lang === 'en'}">{{ i18n("Element.FileUpload") }}</div>
                        <div class="content">                            
                            <input type="file" v-if="canUploadFile" style="width:200px;" @change="onFileSelection"> 
                            <span>已上傳: </span>
                            <a class="fileLink" v-if="showFileLink()" target="_blank" :href="getFileLink()">{{getFileName()}}</a>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="title" :class="{left: lang === 'en'}">{{ i18n("Element.ContentOfCorrespondingActs") }}</div>
                        <div class="content">
                            <textarea cols="10" rows="3" v-model="unElRow.carHandleMemo"></textarea>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="title" :class="{left: lang === 'en'}">{{ i18n("Element.DeadlineForResponse") }}</div>
                        <div class="content">
                            <date-picker :lang="'zh-tw'" 
                            v-if="isAddnew"
                            format="YYYY-MM-DD" valueType="format" v-model="unElRow.carReportDate"></date-picker>
                            <div v-else>{{fixDate(unElRow.carReportDate)}}</div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="title" :class="{left: lang === 'en'}">{{ i18n("Element.VerificationOfEffectiveness") }}</div>
                        <div class="content">
                            <textarea maxlength="50" cols="10" rows="3" v-model="unElRow.carCheckMemo"></textarea>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="title" :class="{left: lang === 'en'}">{{ i18n("Element.AuditDescription") }}</div>
                        <div class="content" v-if="showConfirmUI">
                            <textarea maxlength="50" cols="10" rows="5" v-model="unElRow.carMemo"></textarea>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="title" :class="{left: lang === 'en'}">{{ i18n("Element.Audit") }}&nbsp;&nbsp;</div>
                        <div class="content radio_container"  v-if="showConfirmUI">
                            <span v-for="(item, key) in carStatusListFilter" :key="'carRowStatus_input_' + key">
                                <input type="radio" :name="'car_RowStatusOpt'" v-model="unElRow.carStatus" :value="item.carStatusId" >{{item.carStatusCaption}}
                            </span>                      
                        </div>
                        <div class="content radio_container"  v-else>{{unElRow.carStatusTxt}}</div>
                    </div>
                    <div class="col-md-12">
                        <table class="table table-bordered">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center">{{ i18n("Element.LOGTime") }}</th>
                                    <th class="text-center">{{ i18n("Element.AuditDescription") }}</th>
                                    <th class="text-center">{{ i18n("Element.Status") }}</th>
                                    <th class="text-center">{{ i18n("Element.AssigneeOfUpdate") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item , index) in carLogRows" :key="index">
                                    <td class="text-center">{{fixDateTime(item.logDate)}}</td>
                                    <td class="text-center">{{item.logMemo}}</td>
                                    <td class="text-center">{{getCarStatusTxt(item.logStatus)}}</td>
                                    <td class="text-center">{{item.logCreateusername}}</td>
                                </tr>                                
                            </tbody>
                        </table>
                    </div>

                </div>
            </CCardBody>
        </CCard>

    </div>
</template>
<script>
import $ from "jquery";
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex' 
export default {
    mixins: [qualityMixin],
    data() {
        return {
            carStatusList: this.$t('carStatusList'), //狀態 清單
            carHappenTypeList: this.$t('carHappenTypeList'), //發生類別 清單
            trialMassProductionList: this.$t('trialMassProductionList'), //試作量產 清單
            factoryId : '',
            isReject : false,
            isAddnew : false,
            showConfirmUI : false,
            partnumberList : [{id:'' , text :'                     '}] ,
            unElRow: {
              happenDate : null,
              carLogList: []
            },            
            carLogRows : []            
        }
    },
    props : {
    },
    watch: {
        "lang": function() {
            this.carHappenTypeList = this.$t('carHappenTypeList') //發生類別 清單
            this.trialMassProductionList = this.$t('trialMassProductionList') //試作量產 清單
        }
    },
    methods: {
        partnumberListFilter (){
            return this.partnumberList;            
        },
        getDetail(guid) {//目前編輯的單筆 部材品質異常聯絡單 功能         
            if('new' === guid){                
                this.isAddnew = true;                  
            }else{                
                this.isAddnew = false;                
            }
            const url = `${this.$apiUrl_Quality}/GetUnusualElementDetail/${guid}`
            this.updateLoading(true)
            this.axios.get(url).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功                    
                    const resultRow = response.data
                    this.isReject = false;   
                    this.showConfirmUI = false;
                    if(!this.isAddnew){//編輯狀態
                        if(!this.isMember && resultRow.carStatus !== 4){//非供應商
                            this.showConfirmUI = true;
                        }                        
                    }
                    //4未上傳/0待審核(待判定)/1結案/2退件/3完成並效果追蹤，非退件不得刪除
                    if(resultRow.carStatus === 2){
                        this.isReject = true;
                    }else if(resultRow.carStatus === 1){
                        this.showConfirmUI = false; //完成                        
                    }                    
                    if(resultRow.carLogList){
                        this.carLogRows = resultRow.carLogList;
                        resultRow.carLogList = null;
                    }
                    resultRow.carStatusTxt = this.carStatusMap[resultRow.carStatus];
                    this.unElRow = resultRow;
                    this.unElRow.oldCarStatus = resultRow.carStatus;
                    this.unElRow.hadCarFile = resultRow.carFile;
                    if(this.canSave){
                        this.unElRow.carMemo = '';
                    }
                    this.updateLoading(false)
                }
            })
        },
        checkSaveData (){ //檢核必要儲存資料
            const chkRow= this.unElRow;            
            if(this.isMember || this.isAddnew){
                chkRow.carMemo = ' ';
            }
            if(this.isMember){
                let msg='';
                if(this.isAddnew){
                    if(!chkRow.carFile && !chkRow.fileBase64){
                        msg = '未上傳附件不可儲存！';
                    }                    
                }else{
                    if( !chkRow.fileBase64){
                        msg = '請更新檔案後再上傳！';
                    }                    
                }
                if(msg){
                    this.$alert(msg,'警告',{type: 'warning'});
                    return false;
                }
            }
            if(!chkRow.carMemo){
                this.$alert('審核說明為必要輸入資料！','警告',{type: 'warning'});
                return false;
            }
            if(this.isQMmanager && this.isAddnew && !chkRow.dDown_Trial){
                this.$alert('請選擇試做或量產','警告',{type: 'warning'});
                return false;
            }
            return true;
        },
        savedDataEvent (toContinue){            
            if(!this.checkSaveData()) return;
            if(this.isAddnew){                
                this.unElRow.carStatus = 4;
            }else if(this.isReject || this.isMember){
                this.unElRow.carStatus = 0;
            }else {
                if(this.unElRow.oldCarStatus === 4 && this.unElRow.carFile){
                    this.unElRow.carStatus = 0;
                }
            }
            const url = `${this.$apiUrl_Quality}/UpdateUnusualElementRow`;
            const param = this.unElRow;
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功    
                    if(!toContinue){                
                      this.goBack();
                    }
                }                    
            }); 
        },          
        getCarStatusTxt(status){
            const map =this.carStatusMap;
            let v = map[status];
            if(v){
                return v;
            }
            return '';
        },        
        onFileSelection (e) { //--檔案挑選後，判斷並處理此檔案物件
            const it= this.unElRow;
            const maxFileByte = 5242880;            
            const acceptedImageTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/pdf'];
            // add all selected files
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return false;
            // const self = this;
            let file = files[0];
            let fileType = file['type'];
            let isAccpetType = acceptedImageTypes.includes(fileType);
            if (!isAccpetType) {
                e.target.value = '';
                this.$alert('檔案格式需為 Excel (Excel 2007 以上版本)/ PDF，請重新上傳!','警告',{type: 'warning'});
            } else if (maxFileByte < file.size) {
                e.target.value = '';
                this.$alert('檔案大小需5Mb以下，請重新上傳!','警告',{type: 'warning'});
            } else {                
                const reader = new FileReader();
                reader.readAsDataURL(file);                                 
                reader.onload = function(event) {
                    const itemBase64result = reader.result.substr(event.target.result.indexOf(',') + 1);
                    if(itemBase64result) {
                        it.carFile = file.name;
                        it.fileBase64 = itemBase64result;
                    }
                };
            }
        },
        showFileLink (){
            const it= this.unElRow;
            if(it.hadCarFile){
                return true;
            }
            return false;
        },
        getFileLink (){
            const it= this.unElRow;
            const baseUrl = this.$apiUrl_Quality;
            const carGuid= this.unElRow.carGuid;
            if(it.hadCarFile){
                return `${baseUrl}/CarDownload/${carGuid}`;
            }
            return '';
        },
        getFileName (){
            const it= this.unElRow;
            if(it.hadCarFile){
                return this.fixFileName(it.hadCarFile);
            }
            return '';
        },        
        partnumberSelectEvent({id,maktx}){            
            this.unElRow.partnumber =id;
            this.unElRow.partname = maktx;            
        },        
        getHappenTypeTxt(val){
            const v = this.carHappenTypeMap[val];
            if(v){
                return v;
            }
            return '';
        },
        select2Setting (){
            const self =this;
            const setting = { 
                 multiple: false, 
                 dropdownAutoWidth : true , 
                 width: '100%' ,
                 ajax : self.ajaxSetting()
            };
            return setting;
        },
        ajaxSetting (){           
            const self =this;
            const baseUrl = `${this.$apiUrl_Quality}/GetPartnumberList`;                
            const ajaxObj = {
                url: baseUrl,
                transport: function (params, success) {
                    const keyword = params.data.term;
                    if(keyword && keyword.length >2){
                        const url = `${self.$apiUrl_Quality}/GetPartnumberList?keyword=${keyword}`;
                        self.axios.get(url).then((response) => {      
                            const list = response.data;
                            const rows = []; 
                            if(list && list.length >0){
                                list.forEach(r=> {
                                    rows.push({ id: r.matnr, text: r.matnr ,maktx: r.maktx})
                                });
                            }
                            success(rows);                    
                        });      
                    }else{      
                        success([]); 
                    }
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                }
            };
            return ajaxObj;
        },
        // 試作時，發生類別預設為入檢NG
        changeTrial(){
            // console.log(this.unElRow.dDown_Trial);
            if (this.unElRow.dDown_Trial === "TR") {
                this.unElRow.happenType = 2;
            }
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(["lang"]),
        carStatusMap (){
            return this.listToMap(this.$t('carStatusList'), 'carStatusId' ,'carStatusCaption');
        },
        carHappenTypeMap  (){
            return this.listToMap(this.$t('carHappenTypeList'), 'happenTypeId' ,'happenTypeCaption');
        },        
        canSave (){            
            if(this.unElRow.oldCarStatus && this.unElRow.oldCarStatus === 1){
                return false;//已完成案件都不需處理
            }
            if(this.isAddnew || this.isReject){
                return true;
            }else if(this.unElRow.oldCarStatus === 0 || this.unElRow.oldCarStatus === 3){
                if(!this.isMember){
                    return true;
                }
            }else if(this.unElRow.oldCarStatus === 4){
                if(this.isMember){
                    return true;
                }                
            }
            return false;
        },
        canUploadFile (){
            if(this.isMember && (this.unElRow.oldCarStatus === 0 || this.unElRow.oldCarStatus === 2 || this.unElRow.oldCarStatus === 4)){
                return true;
            }
            return false;
        },
        carHappenTypeListFilter (){
            const list = [];            
            if(this.carHappenTypeList && this.carHappenTypeList.length >0){
                this.carHappenTypeList.forEach(r=>{
                    if(r.happenTypeId > -1){
                        list.push(r);
                    }                    
                });
            }
            return list;
        },
        carStatusListFilter (){
            const list = [];
            if(this.carStatusList && this.carStatusList.length >0){
                this.carStatusList.forEach(r=>{
                    if(r.carStatusId && r.carStatusId != '4'){
                        list.push(r);
                    }                  
                });
            }
            return list;
        }        
    },
    mounted() {        
        //const self = this;
        const carGuid = sessionStorage.getItem('carGuid');
        if(carGuid){
            this.getDetail(carGuid);
        }else{
            this.goBack();
        }
        if(!this.isMember){
            this.initMemberQMList();     
        }         
         
    },
    created() {
        
    }
}	
</script>
<style lang="scss" scoped>
.btn-edit {
    background-color: #343b55;
    color: white;
}

.row {
    padding: 0 12px;
}

.col-md-6 {
    display: flex;
    padding: 0;
    .content {
        flex: 1;

        input[type="radio"] {
            margin: 0 .5rem;
        }
    }

    .title, .content {
        display: flex;
        align-items: center;

        border: solid 1px;
        padding: .6rem 2rem;
    }

    textarea {
        width: 100%;
        margin: 0 .5rem;

        border-radius: 6px;
    }

    input, select {
      width: 100%;
      height: 35px;

      border-radius: 6px;
    }

    .title {
        background-color: #BDD6EE;

        p {
          margin-bottom: 0;
          font-size: 12px;
        }
    }

    .exception {
      flex-direction: column;
      padding: 0.6rem 1.52rem;
    }

    .radio_container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      input[type="radio"] {
        width: auto;
      }

      span {
        display: flex;
        align-items: center;
      }
    }
}

.col-md-12 {
    display: flex;
    padding: 0;

    .title, .content {
        display: flex;
        align-items: center;

        border: solid 1px;
        padding: .6rem 2rem;
    }

    .content {
        flex: 1;

        textarea {
            width: 100%;
            margin: 0 .5rem;

            border-radius: 6px;
        }
    }

    .title {
        background-color: #BDD6EE;
    }

    input, select {
      width: 100%;
      height: 35px;

      border-radius: 6px;
    }

}

.mx-datepicker {
//   min-width: 300px;
}

table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table, .table-bordered th, .table-bordered td {
    border-color: black;
}

.table th {
    // background-color: #FFC300;
    background-color: #FFD966;
    color: #000;
}

.table tr:nth-child(even) {
    background-color: transparent;
}

.input-form {
  display: flex;

  select, input {
    flex: 1;
  }

  select {
    height: 43px;
  }

  input[type=file] {
    height: 100%;
    // border: solid 1px black;
    // border-radius: 5px;
    // margin: 0 0.5rem;
    // padding: 0.5rem 0.2rem;
  }
}

.left {
    // width: 294.5px;
    width: 200px !important;
}

</style>
